module.exports = __webpack_public_path__ + "static/cover-f5450553ef20db5060cfe52f53d0f6da.png";